export default "__VITE_ASSET__CLdI4Rae__"